import SpecialBogo from 'src/dispensary/specials/offer';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';

SpecialBogo.layout = MainDispensaryLayout;
export default SpecialBogo;
